import BaseComponentController from "./base_component_controller"

export default class extends BaseComponentController {
  static targets = ['buttonTemplate', 'trigger']

  static values = {
    content: String
  }

  copy() {
    navigator.clipboard.writeText(this.contentValue)
    if (this.hasButtonTemplateTarget) {
      this.triggerTarget.innerHTML = this.buttonTemplateTarget.innerHTML
    }
  }
}
